import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

type EventWithDates = {
    startDate: string;
    endDate: string;
};

export function displayEventDates(event: EventWithDates, locale: string): string {
    const startDate = new Date(event.startDate);
    const endDate = new Date(event.endDate);

    // If end time is before 9:00 and end date is on a different calendar day than start date,
    // treat it as the previous day (late-night events that cross midnight)
    const displayEndDate = new Date(endDate);
    if (displayEndDate.getHours() < 9 &&
        (startDate.getFullYear() !== endDate.getFullYear() ||
         startDate.getMonth() !== endDate.getMonth() ||
         startDate.getDate() !== endDate.getDate())) {
        displayEndDate.setDate(displayEndDate.getDate() - 1);
    }

    const dayFormatter = new Intl.DateTimeFormat(locale, { day: 'numeric' });
    const monthFormatter = new Intl.DateTimeFormat(locale, { month: 'long' });
    const fullDateFormatter = new Intl.DateTimeFormat(locale, { day: 'numeric', month: 'long', year: 'numeric' });
    const timeFormatter = new Intl.DateTimeFormat(locale, { hour: '2-digit', minute: '2-digit' });

    if (startDate.getFullYear() === displayEndDate.getFullYear() &&
        startDate.getMonth() === displayEndDate.getMonth() &&
        startDate.getDate() === displayEndDate.getDate()) {
            // Same day
            return `${dayFormatter.format(startDate)} ${monthFormatter.format(startDate)} ${startDate.getFullYear()} ${timeFormatter.format(startDate)} - ${timeFormatter.format(endDate)}`;
    } else if (startDate.getFullYear() === displayEndDate.getFullYear() &&
        startDate.getMonth() === displayEndDate.getMonth()) {
            // Same month
            return `${dayFormatter.format(startDate)}-${dayFormatter.format(displayEndDate)} ${monthFormatter.format(startDate)} ${startDate.getFullYear()}`;
    } else {
            // Different months
            return `${fullDateFormatter.format(startDate)} - ${fullDateFormatter.format(displayEndDate)}`;
    }
}

/**
 * Apple Wallet pass download URL for a cashless wallet. The API serves this outside the
 * versioned namespace, so the /api/v1 suffix is stripped from the configured base URL.
 */
export function walletPassDownloadUrl(walletId: string): string {
    const baseUrl = import.meta.env.VITE_API_URL.replace(/\/api\/v1\/?$/, '');
    return `${baseUrl}/wallet/pass/${walletId}/download`;
}
